import { FormattedMessage } from 'react-intl';

import { Select } from '../../../../forms/select/index';
import residentialOptions from '../../../../helpers/residentialOptions';
import residentialOptionMessages from '../../../../helpers/residentialOptions.messages';
import styles from '../PersonModal.module.css';

export const ResidentialStatusQuestion = ({ name }: { name: string }) => {
    return (
        <Select
            name={name}
            label={
                <FormattedMessage
                    id="_.person.residential_status"
                    defaultMessage="Residential status"
                />
            }
            placeholder={
                <FormattedMessage
                    id="_.person.residential_status_placeholder"
                    defaultMessage="Select residential status..."
                />
            }
            selectOptions={{
                classNameSelect: styles.ResidentialStatusSelect,
                options: residentialOptions
            }}
            messages={residentialOptionMessages}
        />
    );
};
